'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const ViewContestant = require('./social_contestant');
const ViewContestantAlt = require('./contestant');
const ViewAd = require('./ad');
const template = require('../templates/live-vote.ejs');
const GA = require('../constants').GOOGLE;
const OMNITURE = require('../constants').OMNITURE;
const slugify = require('slugify');
const PubSub = require('../PubSub');
const { isMobile } = require('../util/is-mobile');

module.exports = Backbone.View.extend({
    className: 'flex-container social-category-live-vote',
    events: {
        'click .btn': 'loadVideo',
        'click .live-vote-btn': 'handleLiveVoteClick'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.cms = options.cms;
        this.appState = this.cms.get('appState');

        this.dimensions = options.dimensions;
        this.user = options.user;

        this.contestantsArray = [];
        this.finalistsArray = [];
        this.hideAnimation = options.hideAnimation || false;
        
        this.copy = options.copy;
        this.transitionTime = (parseInt(this.cms.get('text').customization.transition_time) || 500);

        this.adView = new ViewAd({ 
            categoryIndex: this.model.get('id'),
            adTag: this.model.get('ad_tag') || this.model.get('displayName'),
            model: this.model.get('ad') 
        });
        
        this.listenTo(this.model, 'change:categoryVotesTotal', this.onChangeCategoryVotesTotal.bind(this));
        
        this.listenTo(this.copy, 'change:copy', function() {
            this.render();
            this.renderedToDom();
        }.bind(this));
    },
    /**
     *
     */
    render: function () {
        var model = this.model.toJSON();
        model.copy = _.extend(model.copy, this.copy.get('copy'));
        model.window = this.appState;

        this.$el.css({height: '0'});
        this.$el.html(template(model));

        if(this.contestantsArray.length == 0) {
            this.buildTwitterContestants();
        }

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function() {
        this.$el.parent().css({height: '0px'});

        if(this.model.get('sponsor') == '1' || parseInt(this.model.get('order')) == 1) {
          this.$el.append(this.adView.render().$el);
          this.adView.renderedToDom();
        }

        if(!this.hideAnimation) {
          this.scrollAnimation();
        } else {
          this.$el.parent().css({height: 'auto'});
          this.$el.css({height: 'auto'});
        }
    },

    /**
     * Handler for when the isSubmitted attribute of a category changes
     */
     onChangeCategoryVotesTotal: function( category ) {
        const voteLimit = this.cms.turboVote.get('voteLimit');

        if( category.get('categoryVotesTotal') >= voteLimit ) {
            this.$('.btn-submit').prop('disabled', 'disabled');
            this.$('.btn-submit').removeClass('btn-complete');
            this.$('.btn-submit').removeClass('btn-loading');
            this.$('.btn-submit').text('Limit Reached');
        }
      },
    /**
     * [scrollAnimation description]
     * @return {[type]} [description]
     */
    scrollAnimation: function() {
        const categoryButton = document.querySelector('.category-button[data-category-id="' + this.model.get('id') + '"]');
        const buttonTop = categoryButton.offsetTop;
        const mobileMenuHeight = isMobile.any() ?
                        document.getElementById('header').offsetHeight : 
                        document.getElementById('mtv-mobile-menu').offsetHeight;
        const hasSkybox = document.body.classList.contains('skybox-loaded');
        let skyboxHeight = 0;

        if( hasSkybox ) {
            skyboxHeight = isMobile.any() ?
                        document.querySelector('#mobile_skybox_plus_sticky iframe').offsetHeight :
                        document.querySelector('#skybox_leader_plus_sticky iframe').offsetHeight;
        }

        $('html,body').animate({
            scrollTop: buttonTop - mobileMenuHeight - skyboxHeight
        }, {
            duration: 200,
            complete: function() {
                // fixes issue when the function runs twice due to HTML and body attributes
                if(/(auto)/.test(this.$el.parent().attr('style'))) {
                    return false;
                }
    
                this.$el.parent().css({height: 'auto'});
                this.$el.animate({
                    height: '1200px'
                }, this.transitionTime, function() {
    
                    $(this).css({height: 'auto'});
    
                })
            }.bind(this)
        });

    },
    /**
     *
     */
    buildTwitterContestants: function() {

      var sortedContestants = this.model.get('voteData');
      sortedContestants.sort((a, b) => parseInt(a.order, 10) - parseInt(b.order, 10));

        _.forEach(sortedContestants, function(contestant, index) {

            if(contestant.finalist == '1' && this.cms.get('appState') == 'open') {

                var voteCount = this.model.get('categoryVotes')[contestant.id] ? this.model.get('categoryVotes')[contestant.id] : 0;
                var contestantModel = new Backbone.Model(_.extend({ voteCount: voteCount }, contestant));

                this.finalistsArray.push(new ViewContestant({
                    model: contestantModel,
                    user: this.user,
                    dimensions: this.dimensions,
                    person: this.model.get('person'),
                    copy: this.model.get('copy'),
                    professional: this.model.get('professional'),
                    category: this.model,
                    cms: this.cms,
                    active: this.model.get('active')
                }));

                var currentIndex = this.finalistsArray.length - 1;
                this.$el.find('.finalists').append(this.finalistsArray[currentIndex].render().$el);
                this.finalistsArray[currentIndex].renderedToDom();

            } else {

                var constestantModel = new Backbone.Model(_.extend({ voteCount: null }, contestant));

                this.contestantsArray.push(new ViewContestantAlt({
                    model: constestantModel,
                    user: this.user,
                    dimensions: this.dimensions,
                    person: this.model.get('person'),
                    copy: this.model.get('copy'),
                    cms: this.cms,
                    professional: this.model.get('professional'),
                    category: this.model
                }));

                var currentIndex = this.contestantsArray.length - 1;
                this.$el.append(this.contestantsArray[currentIndex].render().$el);
                this.contestantsArray[currentIndex].renderedToDom();

            }
        }.bind(this));

        if (this.finalistsArray.length > 0) {
            this.$('.finalists').css('display','block');
        };

        if (this.contestantsArray.length > 0) {
            this.$('.runner-up h1').css('display','block');
        }
    },

    handleLiveVoteClick: function(e) {
        var val = "vote on facebook_" + this.model.get('name');
        var href = e.currentTarget.href;

        var omParams = {
          name: val,
          section: slugify(this.model.get('name')),
          destination: href
        };

        PubSub.trigger( 'linkClick', omParams);
    },

    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function() {
        // remove the various Contestants views from the contestants array
        _.forEach(this.contestantsArray, function(value, index) { value.remove(); });
        _.forEach(this.finalistsArray, function(value, index) { value.remove(); });

        this.contestantsArray = null;
        this.finalistsArray = null;

        this.voteData = null;

        if(this.adView) {
            this.adView.remove();
            this.adView = null;
        }

        this.stopListening();
        this.off();

        if(this.copy) {
            this.copy.destroy();
            this.copy = null;
        }

        this.model = null;

        this.recentlyVoted = false;
        this.closedTextDisplayed = false;

        if(typeof this.removeClosedText == 'number') { clearTimeout(this.removeClosedText); console.warn('cancel timeout') };

        return Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/live-vote.js